import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  pricingRequestList: [],
  selectedPricingRequest: null
};

const slice = createSlice({
  name: 'pricingRequest',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      console.debug(`Has Error: ${action.payload.message}`);
      state.error = action.payload.message;
    },

    // GET PRICING REQUEST LIST
    getPricingRequestListSuccess(state, action) {
      state.isLoading = false;
      state.pricingRequestList = action.payload;
    },

    // GET PRICING REQUEST
    getPricingRequestSuccess(state, action) {
      state.isLoading = false;
      state.selectedPricingRequest = action.payload;
    },

    clearPricingRequestDataSuccess(state) {
      state.selectedPricingRequest = initialState.selectedPricingRequest;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow } = slice.actions;

// ----------------------------------------------------------------------

export function getPricingRequestList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query {
        getPricingRequestList {       
            id
            pricingType
            vin
            odometer
            spareKeys
            logBooks
            pricingSla
            onCosts{cost description}
            onCostsTotal
            vehicleAvailability
            vehicleInfo{year make model variant}
            dateCreated
            createdBy
            status
        } 
      }`;

      const response = await axios.post('/graphql', { query: queryString });
      dispatch(
        slice.actions.getPricingRequestListSuccess(
          response.data.data.getPricingRequestList
        )
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getPricingRequest(pricingRequestId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    pricingRequestId = JSON.stringify(pricingRequestId);

    try {
      const queryString = `query {
        getPricingRequest(id:${pricingRequestId})
           {
            id
            pricingType
            vin
            odometer
            spareKeys
            logBooks
            pricingSla
            onCosts{cost description}
            onCostsTotal
            vehicleAvailability
            driveCloudOffer
            dateCreated
            createdBy
            lastUpdated
            status
           }
      }`;

      const response = await axios.post('/graphql', { query: queryString });
      dispatch(
        slice.actions.getPricingRequestSuccess(
          response.data.data.getPricingRequest
        )
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function clearPricingRequestData() {
  return async (dispatch) => {
    dispatch(slice.actions.clearPricingRequestDataSuccess());
  };
}
// ----------------------------------------------------------------------

export async function updatePricingRequest(values) {
  const mappedOnCosts = values.onCosts.map(
    ({ description, cost }) => `{
    description: ${JSON.stringify(description)},
    cost: ${Number(cost)},
}`
  );

  try {
    const queryString = `mutation {
      updatePricingRequest(pricingRequest: {
        id:${JSON.stringify(values.id)},
        pricingType:${JSON.stringify(values.pricingType)}, 
        vin:${JSON.stringify(values.vin)},  
        odometer:${Number(values.odometer)}, 
        spareKeys:${values.spareKeys}, 
        logBooks:${values.logBooks}, 
        vehicleAvailability:${JSON.stringify(values.vehicleAvailability)}, 
        pricingSla:${JSON.stringify(values.pricingSla)}, 
        onCosts: [${mappedOnCosts}],   
        onCostsTotal:${Number(
          String(values.onCostsTotal).replace(/[^0-9]/g, '')
        )},
        driveCloudOffer:${Number(values.driveCloudOffer)},
        dateCreated:${JSON.stringify(values.dateCreated)}, 
        createdBy:${JSON.stringify(values.createdBy)} 
      }) {
        id
      }
      }`;

    const response = await axios.post('/graphql', { query: queryString });
    console.debug(response);
  } catch (error) {
    slice.actions.hasError(error);
  }
}
// ----------------------------------------------------------------------
